export default __webpack_public_path__ + "static/media/element_3.e80a846d.webp";